import React from 'react';
import MenuHome from '../../../components/MenuHome';
import MenuComputerScience from '../../../components/MenuComputerScience';
import MenuProgramming from '../../../components/MenuProgramming';
import { CopyBlock } from "react-code-blocks";
import '../../../styles/main.scss';

const JavaScript = () => {
    const code = `    <script>
        let message = "Hello, World!";
        alert(message);
    </script>`
  return <div>
        <div className="title">JavaScript</div>
        <div class="caption"></div>
        <MenuHome />
        <MenuComputerScience />
        <MenuProgramming />
        <CopyBlock
            text= {code}
            language="javascript"
            showLineNumbers="true"
            theme="dracula"
            />
  </div>;
};

export default JavaScript;